<template>
    <form
        method="POST"
        class="login-form p-3 sm:py-9 sm:px-0 text-ma-gray-3 sm:text-ma-black-1"
        @submit.prevent="submitForm"
    >
        <Message
            v-if="error"
            class="mb-3"
            :message="error"
        />

        <ul>
            <li class="text-left mb-3">
                <label for="login-email" class="uppercase sm:text-ma-black-1 font-bold block mb-1">Email</label>
                <input id="login-email" type="text" v-model="email" name="email" class="w-full p-2 ma-black-1" />
            </li>

            <li class="text-left">
                <label for="login-password" class="uppercase sm:text-ma-black-1 font-bold block mb-1">Password</label>
                <input id="login-password" type="password" v-model="password" name="password" class="w-full p-2 ma-black-1" />
            </li>

            <li class="text-center sm:flex sm:items-stretch sm:text-sm sm:mt-4 sm:mb-6">
                <div class="mt-3 mb-6 sm:text-left sm:my-0 text-sm sm:w-3/5">
                    Forgot password?
                    <router-link to="/account/password/remind/" class="text-ma-blue-1 hover:text-ma-blue-0 font-semibold">Reset password</router-link>
                </div>

                <div class="keep-me-logged pt-1 sm:pt-0 sm:w-2/5">
                    <label class="uppercase font-semibold ma-checkbox justify-center sm:justify-end" :class="{ 'ma-checkbox--checked': remember }">
                        <input type="checkbox" v-model="remember" name="remember_me" />
                        <span class="ma-checkbox__toggle"></span>
                        <div class="ma-checkbox__label">
                            Keep me logged in
                        </div>
                    </label>
                </div>
            </li>

            <li class="text-center">
                <button
                    type="submit"
                    class="ma-btn ma-btn--blue w-full sm:w-48 sm:mx-auto"
                    :class="{ 'opacity-50': loading }"
                    :disabled="loading"
                >
                    <div
                        v-show="loading"
                        class="animation-spin inline-block mr-2"
                    >
                        <i class="icon-spinner2"></i>
                    </div>
                    Log In
                </button>
            </li>

            <li class="text-center my-9 sm:mb-0 text-sm">
                Don&rsquo;t have an account? <a href="/pricing" class="text-ma-blue-1 hover:text-ma-blue-0 font-semibold">Sign up</a>
            </li>
        </ul>

    </form>
</template>

<script>
    import axios from 'axios';
    import Message from '@/components/Message';
    import updateDeviceToken from '@@/assets/site/js/lib/update-device-token'
    import analyticsEvents from '../../../utils/analyticsEvents';
    import { identify, eventTracker } from "@/utils/eventTracker";

    export default {
        components: {
            Message
        },

        data: () => ({
            error: '',
            email: '',
            password: '',
            loading: false,
            remember: true,
        }),

        methods: {
            async submitForm() {
                eventTracker(analyticsEvents.clickLogin);
                if (this.loading) {
                    return
                }

                // Validation
                if (!this.validateEmail(this.email) || !this.password) {
                    this.error = 'Invalid email address/password.'
                    return
                }

                this.loading = true;

                let deviceToken = updateDeviceToken.getOrUpdateToken();

                try {
                    let response = await axios.post('/api/sign-in', {
                        email: this.email,
                        password: this.password,
                        remember_me: this.remember,
                        device_token: deviceToken
                    });
                    identify(response.data.user_id.toString());

                    if (response.data && response.data.redirect) {
                        eventTracker(analyticsEvents.loginSuccess);
                        window.location.href = response.data.redirect;
                    } else {
                        // Sanity handler
                        console.info(response)
                        window.location.href = '/browse';
                    }
                } catch (e) {
                    console.error(e)

                    this.loading = false;

                    if (e.response) {
                        this.error = e.response.data.message || 'There seems to be a problem on our end. Please contact our support to report.';
                    } else {
                        // Request was made but no response was received.
                        // Or something happened in setting up the request that triggered an Error.
                        this.error = 'There seems to be a problem on your end. Please contact our support for help.';
                    }
                }
            },

            validateEmail(email) {
                const re = /\S+@\S+\.\S+/;
                return re.test(email);
            }
        }
    }
</script>
